<template>
  <div class="info-section-3">

    <div class="info-container">
      <product-title
        main-title="LMS"
        sub-title="Learning Management System"
        :is-left=true
      />

      <info-box
        boxTitle="Lorem Ipsum Title"
        boxContent="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
   been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
   scrambled it to make a type specimen book. "
      />

    </div>

    <div class="laptop-asset-container" ref="info3ScrollContainer">
      <img class="asset-mockup image-tint" ref="info3ScrollImg" src="../assets/mockup-images/mac-mockup-02.png" alt="">
    </div>

  </div>
</template>

<script>
import ProductTitle from "../components/productComponents/ProductTitle";
import InfoBox from "../components/productComponents/InfoBox";
import scroll from "../mixins/scroll";

export default {
  name: 'InfoSection3',
  mixins: [scroll],
  components: {InfoBox, ProductTitle},

  mounted() {
    if (this.$refs.info3ScrollContainer && this.$refs.info3ScrollImg) {
      this.refScrollContainer = 'info3ScrollContainer'
      this.refScrollImg = 'info3ScrollImg'
      window.addEventListener("scroll", this.scrolling)
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.scrolling)
  }
}
</script>

<style lang="scss">
@import "InfoSection3.scss";
</style>
